import * as DataGrid from "../devextreme/datagrid";
import { databasePack } from "../devextreme/plugins";
import { urlCellTemplate, versionnedStorageKey } from "../framework/tabulars";

const $container = document.querySelector("#program-agreements-datagrid");

if ($container) {
  const storageKey = versionnedStorageKey("program-agreements-datagrid", 0);

  DataGrid.create({
    container: $container,
    plugins: [
      databasePack({
        columnOverrides: programAgreementColumnOverrides(),
        storageKey,
      }),
    ],
  });
}

function programAgreementColumnOverrides() {
  return {
    program_name: {
      cellTemplate: programAgreementCellTemplate,
      visible: true,
      visibleIndex: 1,
    },
    number: {
      visible: true,
    },
    customer_funding_count: {
      visible: true,
    },
  };
}

function programAgreementCellTemplate(container, options) {
  const url = `/measure_numbers/${options.row.data.id}/edit`;
  urlCellTemplate(url, options.displayValue, container);
}
